import { PageHeader } from "@/components/common/Loader";
import StaffManager from "@/pages/admin/settings/StaffManager";

export default function Staff() {
  return (
    <div>
      <PageHeader eyebrow="Super Admin" title="Staff" subtitle="Aggiungi amministratori, cambia il loro ruolo o disattivali." />
      <StaffManager />
    </div>
  );
}
